import { EmbedProvider } from './types';

export default [EmbedProvider.AOL, EmbedProvider.FoxNews];
